import React from 'react';
import { Box, useTheme } from '@mui/material';

interface TableStyleWrapperProps {
  children: React.ReactNode;
}

/**
 * TableStyleWrapper provides consistent table styling with proper dark mode support
 * Wrap table components with this to ensure proper light/dark mode rendering
 */
export const TableStyleWrapper: React.FC<TableStyleWrapperProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '& .MuiTableHead-root': {
          '& .MuiTableRow-root': {
            backgroundColor: theme.palette.background.paper,
            '& .MuiTableCell-root': {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              borderBottom: `2px solid ${theme.palette.divider}`,
              fontWeight: 600,
              padding: '12px 16px',
            },
          },
        },
        '& .MuiTableBody-root': {
          '& .MuiTableRow-root': {
            backgroundColor: theme.palette.background.paper,
            '&:nth-of-type(odd)': {
              backgroundColor:
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
            },
            '&:hover': {
              backgroundColor:
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.07)',
            },
            '& .MuiTableCell-root': {
              color: theme.palette.text.primary,
              borderBottom: `1px solid ${theme.palette.divider}`,
              padding: '12px 16px',
            },
          },
        },
        // Styling for input fields inside tables
        '& .MuiTextField-root': {
          '& .MuiInputBase-input': {
            color: theme.palette.text.primary,
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: theme.palette.divider,
            },
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
            },
          },
        },
      }}
    >
      {children}
    </Box>
  );
};
